import Tooltip from './Tooltip';

import './styles/style.scss';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js